import { render } from "./reportheadertab.vue?vue&type=template&id=711dd654&scoped=true"
import script from "./reportheadertab.vue?vue&type=script&lang=js"
export * from "./reportheadertab.vue?vue&type=script&lang=js"

import "./reportheadertab.vue?vue&type=style&index=0&id=711dd654&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-711dd654"]])

export default __exports__